import { Avatar, Button, Card, Space, Statistic, Tag, Typography } from 'antd';
import dayjs from 'dayjs';

import type { DayResult, JobFlight } from '../../../src/types.ts';
import { fmtStops } from '../lib/format.ts';

interface Props {
  day: DayResult;
  flight: JobFlight;
  onOpen: () => void;
  onBook: () => void;
}

export function CheapestCard({ day, flight, onOpen, onBook }: Props) {
  return (
    <Card size="small" style={{ borderColor: '#302b78' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <Space orientation="vertical" size={2}>
          <Tag color="#302b78" style={{ marginInlineEnd: 0 }}>
            Cheapest day
          </Tag>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {dayjs(day.date).format('dddd, D MMMM')}
          </Typography.Title>
          <Space size={8}>
            {flight.airlineLogo ? <Avatar size="small" src={flight.airlineLogo} /> : null}
            <Typography.Text type="secondary">
              {flight.airline || 'Unknown'}
              {' · '}
              {fmtStops(flight.stops)}
              {flight.returnDate ? ` · return ${flight.returnDate}` : ''}
              {flight.provider ? ` · via ${flight.provider}` : ''}
            </Typography.Text>
          </Space>
        </Space>
        <Space size={16} wrap>
          <Statistic value={flight.price} precision={flight.price >= 1000 ? 0 : 2} suffix={flight.currency} styles={{ content: { color: '#302b78', fontWeight: 700 } }} />
          <Space>
            <Button onClick={onOpen}>All fares that day</Button>
            <Button type="primary" onClick={onBook}>
              Book
            </Button>
          </Space>
        </Space>
      </div>
    </Card>
  );
}
